{
  "en": {
    "upload": {
      "labels": {
        "cancelUpload": "Cancel Upload",
        "cancelUploadConfirmation": "Are you sure you want to cancel this upload?",
        "chooseCategory": "Click to select a category first",
        "defaultMessage": "Add or drop files",
        "fallbackMessage": "Your browser does not support drag'n'drop file uploads.",
        "fallbackText": "Please use the fallback form below to upload your files like in the olden days.",
        "fileTooBig": "File is too big ({filesize} MB). Max filesize: {maxFilesize} MB.",
        "invalidFileType": "You can't upload files of this type.",
        "maxFilesExceeded": "You can not upload any more files.",
        "noExtension": "File has no extension",
        "rejectedFiles": "The following files were rejected:",
        "removeFile": "Remove file",
        "responseError": "Server responded with {statusCode} code.",
        "uploadConfirmation": "Upload Confirmed",
        "uploadError": "Upload error",
        "warningMaxFileSize": "Up to {max_files_size} each"
      }
    }
  }
}
